import { Component } from '@theme/component';
import { fetchConfig } from '@theme/utilities';
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/**
 * "Comprar Junto" card (blocks/_product-buy-together.liquid). Adds only that
 * card's own product/variant to the cart — never the PDP's main product.
 * Mirrors the cart-add/refresh flow already used by product-kit.js.
 */
class ProductBuyTogetherItem extends Component {
  requiredRefs = ['addButton'];

  /** @param {Event} event */
  add(event) {
    event.preventDefault();

    const { addButton, variantSelect } = this.refs;
    let variantId = this.dataset.defaultVariantId;

    if (variantSelect instanceof HTMLSelectElement) {
      if (!variantSelect.value) {
        variantSelect.reportValidity();
        return;
      }
      variantId = variantSelect.value;
    }

    if (!variantId) return;

    addButton.setAttribute('disabled', 'true');

    fetch(Theme.routes.cart_add_url, {
      ...fetchConfig('json'),
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          throw new Error(response.message || 'Add to cart failed');
        }

        return this.#refreshCart();
      })
      .then(() => {
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product-buy-together',
            lines: [{ merchandiseId: variantId, quantity: 1 }],
            promise: Promise.resolve({ detail: { didError: false } }),
          })
        );
      })
      .catch((error) => {
        console.error(error);
        this.dispatchEvent(new CartErrorEvent({ error: error?.message, code: 'INVALID' }));
      })
      .finally(() => {
        addButton.removeAttribute('disabled');
      });
  }

  async #refreshCart() {
    const cartItemsComponent = document.querySelector('cart-items-component');

    if (cartItemsComponent && typeof (/** @type {any} */ (cartItemsComponent).fetchCartData) === 'function') {
      return /** @type {any} */ (cartItemsComponent).fetchCartData();
    }

    return fetch(`${Theme.routes.cart_url}.json`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then((response) => response.json());
  }
}

customElements.define('product-buy-together-item', ProductBuyTogetherItem);
